module.exports = __webpack_public_path__ + "img/elementlengths_jaka.9fd7449a.png";